//@ts-ignore
export default {
  routes: [],
  route: {},
}
